import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validates a username with the following rules:
 * - Length: 4 to 30 characters
 * - Allowed characters: letters (a–z, A–Z), digits (0–9), dot (.), underscore (_), hyphen (-)
 * - Must start and end with a letter or digit
 * - Disallows consecutive special characters like "..", "__", "--", ".-", etc.
 * - No spaces or disallowed symbols (e.g. @, #, <, >)
 */
export function usernameValidator(control: AbstractControl): ValidationErrors | null {
  const value = (control.value || '').trim();
  const valid = /^(?=.{4,30}$)[a-zA-Z0-9](?:(?![._-]{2})[a-zA-Z0-9._-])*[a-zA-Z0-9]$/.test(value);

  if (!valid) {
    return { invalidUsername: true };
  }
  return null;
}
